import React from 'react';
import DonationWidget from './widget/DonationWidget';

interface DonationSectionProps {
  showError: string;
  onSuccess: (amount: number) => void;
  onError: (error: string) => void;
}

const DonationSection: React.FC<DonationSectionProps> = ({ showError, onSuccess, onError }) => {
  return (
    <section id="donate" className="donation-section">
      <div className="donation-main-container">
        <div className="donation-left-container">
          <h2>Every donation counts...</h2>
          <p>Give now and join Goodbye Malaria on a lifesaving journey towards malaria elimination.</p>
        </div>
        <div className="donation-right-container">
          <DonationWidget onSuccess={onSuccess} onError={onError} />
        </div>
      </div>
    </section>
  );
};

export default DonationSection;
